import React, { PureComponent } from 'react';
import ConfigurationFields from '../../../elements/configViews/ConfigurationFields';
import { CONNECTION_CATEGORY_KAFKA } from '../../../../constants/connectionCategories';

class KafkaSinkConfiguration extends PureComponent {
  render() {
    const { config } = this.props;

    return (
      <ConfigurationFields
        {...this.props}
        connectionCategory={CONNECTION_CATEGORY_KAFKA}
        config={config}
      />
    );
  }
}

export default KafkaSinkConfiguration;
